module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image5c"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "142",
      "src": "images/ak.jpg",
      "width": "300"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The day Howard Books contacted me regarding publishing this book, the U.S. Navy Reserves mobilized my husband. He left a month later to spend more than a year in Iraq, leaving me with four kids and an incomplete manuscript. To say I owe a huge debt of gratitude to those who supported me would be a gross understatement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many thanks . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To God: for Your sense of timing, sense of humor, and unfailing love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Kevin: for your unwavering belief in me, your strength, and your willingness to sacrifice in order to serve others. You lead by example. I am proud to call you husband.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my parents: for being my first editors and fans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my in-laws: for being there, cheerleading, and child care.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("To my kids: for allowing me to write and “not work for you” for a season.")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("To my siblings: for early morning phone calls, frequent e-mails, and your prayers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Barbara and Liisa: for hanging in and hanging out with me. To the staff at Faith Church: for your incredible enthusiasm, grace, and dinner every Tuesday for a year! I am blessed to serve alongside you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Faith Writers: for your encouragement, critique, and companionship on this journey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my Faith Church family: for your prayers, kind deeds, and many meals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Write to Publish: for giving me knowledge and opportunity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Denny, Chrys, and the rest of the Howard Books family: for caring about my book and my family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Dawn at Between the Lines: for adding clarity to my vision for this project.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fcc4654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 75
// module chunks = 0